import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, Row} from "react-bootstrap";
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import configInfo from '../config/config.json';
import { translateAPIError } from '../utils/apiUtils';


const DeptAdminNewView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  i18n.loadLanguages(['en']);
  i18n.loadLanguages(['zh_HK']);
  i18n.loadLanguages(['zh_CN']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [deptAttrs, setDeptAttrs] = useState({
    deptCode: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    description: ''
  });

  // UI Functions

  const [errMsg, setErrMsg] = useState('');
  const [deptList, setDeptList] = useState([]);

  // Initialize state
  useEffect(() => {
    fetchDepts();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDepts = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments");

        resolve(res.data);

        if (res.status === 200) {

          for (let i=0; i<res.data.length; i++) {
            res.data[i].displayName = [];
            res.data[i].displayName['en']    = res.data[i].name;
            res.data[i].displayName['zh_HK'] = res.data[i].nameLang2;
            res.data[i].displayName['zh_CN'] = res.data[i].nameLang3;
          }

          // Insert a value to represent no parent
          let newNode = {deptCode: "NO_PARENT",
                         id: -1,
                         name: t("I18N_No_parent_dept", { lng: 'en' }),
                         nameLang2: t("I18N_No_parent_dept", { lng: 'zh_HK' }),
                         nameLang3: t("I18N_No_parent_dept", { lng: 'zh_CN' }),
                         displayName: []};

          newNode.displayName['en']    = t("I18N_No_parent_dept", { lng: 'en' });
          newNode.displayName['zh_HK'] = t("I18N_No_parent_dept", { lng: 'zh_HK' });
          newNode.displayName['zh_CN'] = t("I18N_No_parent_dept", { lng: 'zh_CN' });

          res.data.unshift (newNode);

          setDeptList(res.data);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const onAttrsInputChange = (e) => {
    setDeptAttrs({ ...deptAttrs, [e.target.name]: e.target.value })
  }

  const onDeptClick = (key, event) => {
    let dept = deptList.find(item => item.id === key);

    setDeptAttrs({ ...deptAttrs, parentDeptId: dept.id })
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!deptAttrs.deptCode || deptAttrs.deptCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_deptCode"));
      return;
    } else if (deptAttrs.deptCode.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 30);
      return;
    } else if (!deptAttrs.name || deptAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (deptAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");
      return;
    } else if (!deptAttrs.nameLang2 || deptAttrs.nameLang2.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_2") + ")");
      return;
    } else if (deptAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;
    } else if (!deptAttrs.nameLang3 || deptAttrs.nameLang3.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_3") + ")");
      return;
    } else if (deptAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;
    } else if (!deptAttrs.parentDeptId) {
      setErrMsg(t("I18N_ERR_Need_parent_dept"));
      return;
    }

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(deptAttrs));

    // Removing leading and trailing spaces
    reqBody.deptCode    = deptAttrs.deptCode    ? deptAttrs.deptCode.trim()    : deptAttrs.deptCode;
    reqBody.name        = deptAttrs.name        ? deptAttrs.name.trim()        : deptAttrs.name;
    reqBody.nameLang2   = deptAttrs.nameLang2   ? deptAttrs.nameLang2.trim()   : deptAttrs.nameLang2;
    reqBody.nameLang3   = deptAttrs.nameLang3   ? deptAttrs.nameLang3.trim()   : deptAttrs.nameLang3;
    reqBody.description = deptAttrs.description ? deptAttrs.description.trim() : deptAttrs.description;

    if (deptAttrs.parentDeptId === -1) {
      reqBody.parentDeptId = null;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.post("departments", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', height: '800px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Dept")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Dept_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Dept_code")}: *</Col>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              { configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                <Col md={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}: *</Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                <Col md={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}: *</Col>
              : null
              }
              { !configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                <Col></Col>
              : null
              }
              { !configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                <Col></Col>
              : null
              }
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="deptCode" value={deptAttrs.deptCode}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="name" value={deptAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              { configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                <Col md={3}>
                  <input className={classes.admin_pages__field_editable} name="nameLang2" value={deptAttrs.nameLang2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                <Col md={3}>
                  <input className={classes.admin_pages__field_editable} name="nameLang3" value={deptAttrs.nameLang3}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
              { !configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                <Col></Col>
              : null
              }
              { !configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                <Col></Col>
              : null
              }
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col md={3}>{t("I18N_Parent_dept")}: *</Col>
              <Col md={3}>{t("I18N_Description")}:</Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
{/*
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={!deptAttrs.parentDeptId ? t("common:I18N_DROPDOWN_PROMPT") :
                           deptList.find(item => item.id.toString() === deptAttrs.parentDeptId.toString()).displayName[i18n.language]}
                    onSelect={onDeptSelect}>
                    {deptList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                          {item.displayName[i18n.language]}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                    {!deptAttrs.parentDeptId ? t("common:I18N_DROPDOWN_PROMPT") :
                           deptList.find(item => item.id.toString() === deptAttrs.parentDeptId.toString()).displayName[i18n.language]}
                    {deptAttrs.parentDeptId}
                    {!deptAttrs.parentDeptId ? 'false' : 'true'}
*/}
                <Dropdown>
                  <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                    {!deptAttrs.parentDeptId ? t("common:I18N_DROPDOWN_PROMPT") :
                           deptList.find(item => item.id.toString() === deptAttrs.parentDeptId.toString()).displayName[i18n.language]}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                    {deptList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onDeptClick(item.id)}>
                          {item.displayName[i18n.language]}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={deptAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default DeptAdminNewView;
